class StockLocationStockListController extends AbstractStockLocationController
	@register()
	@inject 'stockLocation',
		'ConfigurationService',
		'StockLocationRepository'
		'shops'
		'SEARCH_CONFIGURATION'

	initialize: ->
		super()

		searchConfiguration = angular.copy(@SEARCH_CONFIGURATION.stock_list)

		if @ConfigurationService.isEnabled('Shared.Setting.Product.MultipleSku.Enabled')
			searchConfiguration.product_sku.options.additional_conditions.push({property: 'product_skus>value'})
			searchConfiguration.product_sku.options.additional_conditions.push({property: 'product_variants>product_variant_skus>value'})

		@filterDTO = new FilterDTO({
			searchConfiguration: searchConfiguration
			pageSize: @StockLocationRepository.getPageSize()
			itemsCount: 0
			sortProperty: 'name'
			sortDirection: 'ASC'
		})

		@products = []
		@reportContext = {
			id: @stockLocation.id
		}


	search: ->
		@searching = true

		@reportContext = @filterDTO.getFilter()
		@reportContext.id = @stockLocation.id

		query = @filterDTO.getQuery()

		@StockLocationRepository
			.getProducts @stockLocation.id, query
			.then (response) =>
				@prepareProducts response
			.catch (response) =>
				@handleErrors response
			.finally =>
				@searching = false

	filterStockValues: (product) ->
		product.stock_values = _.filter(product.stock_values, (stockValue) =>
			stockValue.stock_location_id == @stockLocation.id
		)

	prepareProducts: (products) ->
		@products = products
		@filterDTO.itemsCount = @products.length

		for product in @products
			product.expanded = false
			product.cost_price ?= 0
			product.total_quantity = parseFloat(product.quantity || 0).toFixed(3).replace('.000', '')
			product.total_cost  = parseInt(product.cost_price)

	onProductSelect: (product) ->
		product.expanded = !product.expanded

		if !product.expanded || parseInt(product.variants_count) == 0 || product.variants?
			return

		@searching = true

		filter = @filterDTO.getFilter()

		query = @StockLocationRepository.createQuery()

		if filter.product_sku?
			criteria = query.criteria('product_variants.sku', 'LIKE', filter.product_sku)

			if @ConfigurationService.isEnabled('Shared.Setting.Product.MultipleSku.Enabled')
				criteria.or('product_variants.product_variant_skus.value', 'LIKE', filter.product_sku)

		if filter.supplier_id?
			criteria = query.criteria('product_variants.supplier_id', '=', filter.supplier_id)

			if product.supplier_id == filter.supplier_id
				criteria.or('product_variants.supplier_id', 'IS', null)

		@StockLocationRepository
			.getProductVariants @stockLocation.id, product.id, query
			.then (response) =>
				product.variants = response

				for variant in product.variants
					quantity = variant.quantity || 0

					if quantity % 1 == 0
						variant.quantity = parseInt(quantity)
					else
						variant.quantity = parseFloat(quantity).toFixed(3).replace('.000', '')
			.catch (response) =>
				@handleErrors response
			.finally =>
				@searching = false
